<template>
    <button 
        type="button" 
        class="btn btn-sm btn-outline-theme"
        @click="openScheduleServiceModal"
    >
        <i class="bi bi-plus-circle pe-1"></i> Schedule a Service
    </button>
    
    <!-- Setup recurring service component -->
    <SetupRecurringServices
        ref="setupScheduleServices"
        :services="services"
        :address-id="addressId"
        :customer-id="customerId"
        :source="source"
        :can-add-service="true"
    />
</template>

<script>
import SetupRecurringServices from '../Order/SetupRecurringServices.vue';
export default {
    name: "SetupScheduleServiceButton",
    components: {
        SetupRecurringServices
    },
    props: {
        addressId: {
            type: [Number, String],
            default: null
        },
        customerId: {
            type: [Number, String],
            default: null
        },
        source: {
            type: String,
            default: 'scheduled-services'
        }
    },
    data() {
        return {
            services: []
        }
    },
    mounted() {
        this.getServices();
    },
    methods: {
        getServices() {
            
        },
        openScheduleServiceModal() {
            this.$refs.setupScheduleServices.openModal();
        }
    }
}
</script>